<template>
  <w-flex class="breadcrumbs-bar">
    <w-flex class="breadcrumbs-bar__list" align="center" :gap="3">
      <template v-for="(breadcrumb, index) in breadcrumbLinks" :key="'breadcrumb' + index">
        <w-button
          class="breadcrumbs-bar__item"
          variant="ghost"
          size="xs"
          :href="breadcrumb.Url"
          :icon="breadcrumb.Icon"
        >
          <span class="breadcrumbs-bar__item__text">{{ breadcrumb.Title }}</span>
        </w-button>

        <span v-if="index < breadcrumbLinks.length - 1"> / </span>
      </template>
    </w-flex>
  </w-flex>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

import type { BreadcrumbItem } from '@/typings/breadcrumbItem';

/**
 * Layout przed zalogowaniem
 */
export default defineComponent({
  props: {
    breadcrumbLinks: {
      type: Array as () => BreadcrumbItem[],
      required: true,
    },
  },
});
</script>

<style lang="scss">
.breadcrumbs-bar {
  background: w.color('neutral', 40);
  color: w.color('neutral', 600);
  font-size: w.font('small');
  padding: calc(w.size('layout-padding') / 2) w.size('layout-padding');

  @include w.media-lg {
    padding: calc(w.size('layout-padding--lg') / 2) w.size('layout-padding--lg');
  }

  @include w.media-md {
    padding: calc(w.size('layout-padding--md') / 2) w.size('layout-padding--md');
  }

  display: flex;

  &__list {
    display: flex;
    gap: 8px;
  }

  &__item {
    text-decoration: none;
    padding-left: 4px;
    padding-right: 4px;
    color: w.color('neutral', 600);

    &__text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 15vw;
    }
  }
}
</style>
